import { getAppAuthToken } from './auth';

const CONFIG = {
  method: '',
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'same-origin',
  redirect: 'follow',
  referrerPolicy: 'no-referrer',
};

const createNetworkResponseLisenner = () => {
  let list = [];
  let listeners = [];

  const addListener = callback => {
    listeners.push(callback);
    return () => {
      listeners = listeners.filter(l => l !== callback);
    };
  };

  const add = res => {
    list = [...list, res];
    notify();
  };

  const get = () => {
    return list;
  };

  const notify = () => {
    listeners.forEach(cb => cb(list));
  };

  return {
    add,
    get,
    addListener,
  };
};

export const networkResponseLisenner = createNetworkResponseLisenner();

export const createQueryParams = (data = {}) => {
  const params = new URLSearchParams();
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      params.append(key, data[key]);
    }
  }
  return params.toString();
};

const api = async (method, url, content) => {
  CONFIG['method'] = method;

  if (method === 'GET') url += '?/' + createQueryParams(content);
  if (method === 'POST') CONFIG['body'] = JSON.stringify(content);

  if (getAppAuthToken()) {
    CONFIG['headers'] = {
      'Auth-Token': getAppAuthToken(),
    };
  }
  // @ts-ignore
  const response = await fetch(url, CONFIG);

  networkResponseLisenner.add(response);

  if (!response.ok) {
    if (response.status === 500) throw new Error('Network response was not OK');

    return response;
  }

  const data = await response.json();
  data['status'] = response.status;

  return data;
};

export default api;
